import Vue from 'vue'
import Router from 'vue-router'
import PartsSearchPage from './components/PartsSearchPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PartsSearchPage',
      component: PartsSearchPage
    }
  ]
}) 